module.exports = __webpack_public_path__ + "static/media/red-trash.c51478e5.svg";